import React, { useState } from 'react';
import { AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import Stats from './Stats';
import Filter from './Filter';
import CustomTooltip from './Tooltip';
import colors from '../../colors';
import { getTimeFilteredData } from '../utils';

const TimeSeriesChart = ({
  data,
  stats,
  isFilterable,
  filterList,
  hasTooltip,
  showTotalValue,
  height,
  color,
  className = '',
  style = {}
}) => {
  const [selectedFilter, setSelectedFilter] = useState('All time');
  const dataFiltered = getTimeFilteredData(data, selectedFilter);
  const total = dataFiltered.reduce((prev, next) => prev + next.value, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: `chart__time-series-container ${className}`,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "chart__time-seriest-header"
  }, (stats || showTotalValue) && /*#__PURE__*/React.createElement(Stats, {
    stats: stats,
    showTotalValue: showTotalValue,
    total: total
  }), isFilterable && /*#__PURE__*/React.createElement(Filter, {
    filterList: filterList,
    selectedFilter: selectedFilter,
    setSelectedFilter: setSelectedFilter
  })), /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: height
  }, /*#__PURE__*/React.createElement(AreaChart, {
    data: dataFiltered,
    margin: {
      top: 0,
      left: -32,
      right: 0,
      bottom: 0
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: color,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: color,
    stopOpacity: 0.1
  }))), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "date"
  }), /*#__PURE__*/React.createElement(YAxis, {
    dataKey: "value"
  }), /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "2 2",
    stroke: colors['border-darken']
  }), hasTooltip && /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(CustomTooltip, null)
  }), dataFiltered.length ? /*#__PURE__*/React.createElement(Area, {
    dataKey: "value",
    stroke: color,
    strokeWidth: 1,
    fillOpacity: 0.3,
    fill: "url(#gradient)"
  }) : /*#__PURE__*/React.createElement("text", {
    x: "50",
    y: "30",
    style: {
      fill: colors['text-secondary'],
      fontSize: 14
    }
  }, "No data available"))));
};

TimeSeriesChart.defaultProps = {
  stats: [],
  isFilterable: true,
  filterList: ['All time', 'Last year', 'Last 6 months', 'Last 3 months', 'Last month', 'Last week'],
  hasTooltip: true,
  showTotalValue: false,
  height: 300,
  color: colors.primary
};
TimeSeriesChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  stats: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    stat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })),
  isFilterable: PropTypes.bool,
  filterList: PropTypes.arrayOf(PropTypes.oneOf(['All time', 'Last year', 'Last 6 months', 'Last 3 months', 'Last month', 'Last week'])),
  hasTooltip: PropTypes.bool,
  showTotalValue: PropTypes.bool,
  height: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default TimeSeriesChart;